import { useAppSelector } from '../../hooks/app';
import { selectStreamProfileIncidents, selectStreamProfiles, selectStreamProfilesLoaded } from './selectors';

export const useStreamProfiles = () => useAppSelector(selectStreamProfiles);
export const useStreamProfilesLoaded = () => useAppSelector(selectStreamProfilesLoaded);
export const useStreamProfileIncidents = () => useAppSelector(selectStreamProfileIncidents);
